import { Helmet } from "react-helmet-async";

export default function CarLoanPage() {
    return (
      <div className="w-full min-h-screen bg-gray-100 p-4">
         <Helmet>
                <title>Kota HOLDINGS</title>
                <meta name="description" content="A Vision of My 30-Year World" />
              </Helmet>
        <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-[#FF6F00] text-white p-6">
            <h2 className="text-2xl font-bold">Drive Your Dream Car with Our Car Loan</h2>
            <p className="mt-2">Get instant approval for car loans with flexible terms and competitive interest rates.</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
              <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
              <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
            </div>
            <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
            <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Apply Now</button>
          </div>
        </div>
        <div className="mx-auto overflow-hidden mt-6">
          <div className="p-6">
            <h3 className="text-xl font-bold">Features and Benefits of our Car Loan</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Access to Immediate Funds</li>
              <li>Flexible Loan Tenures</li>
              <li>Fixed Interest Rates</li>
              <li>Customized Loan Amounts</li>
              <li>Convenient Monthly Repayments</li>
              <li>Potential Tax Benefits</li>
              <li>Option for New and Used Cars</li>
              <li>Ownership from Day One</li>
              <li>No Need for Full Upfront Payment</li>
              <li>Improve Credit Score through Timely Payments</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Car Loan Eligibility</h3>
            <p>Car loan eligibility depends on income, credit score, and existing debts. Meeting lender criteria ensures loan approval.</p>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Car Loan Eligibility Criteria</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Age: 21 to 65 years</li>
              <li>Minimum Income: INR 20,000 per month</li>
              <li>Good Credit Score: 650 or above</li>
              <li>Stable employment or business history</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Eligibility for Salaried & Self-Employed Individuals</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Salaried: Minimum 2 years of work experience, Rs. 3,00,000 per year income</li>
              <li>Self-Employed: Minimum 2 years in business, Rs. 3,000,000 per year income</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Documents Required for Car Loan</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>KYC Documents (Valid Photo ID Proofs)</li>
              <li>PAN Card</li>
              <li>Last 2 years' ITR as proof of income</li>
              <li>Salary Slip (latest 3 months)</li>
              <li>Salary account statement (latest 6 months)</li>
              <li>Signature Verification Proof</li>
            </ul>
          </div>
        </div>
      </div>
    );
}
